export const mode = process.env.REACT_APP_MODE as 'swap' | 'buy';

export const isSwap = mode.toLowerCase() === 'swap';
export const isBuy = mode.toLowerCase() === 'buy';
